import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { rydeColors } from "@ryde/theme";

export const ProductionNoResultStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "production-no-result",
})`
  padding-top: 44px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 25px;

  .ProductionNoResult-Title {
    font-size: 18px;
    font-weight: 600;
    color: ${rydeColors.purpleTitle};
  }

  .ProductionNoResult-TitleAddition {
    color: ${rydeColors.lightGreen};
  }

  .ProductionNoResult-CloseButton > div[data-e2e="button-content"] {
    text-decoration: underline;
  }
`;
